/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S5_Li3Inputs */

const en_guide_large_json_files_s5_li3 = /** @type {(inputs: Guide_Large_Json_Files_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Parquet/Avro</strong>: Binary formats optimized for large dataset analytics`)
};

const ko_guide_large_json_files_s5_li3 = /** @type {(inputs: Guide_Large_Json_Files_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Parquet/Avro</strong>: 대규모 데이터셋 분석에 최적화된 바이너리 포맷`)
};

const ja_guide_large_json_files_s5_li3 = /** @type {(inputs: Guide_Large_Json_Files_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Parquet/Avro</strong>: 大規模データセット分析に最適化されたバイナリ形式`)
};

/**
* | output |
* | --- |
* | "<strong>Parquet/Avro</strong>: Binary formats optimized for large dataset analytics" |
*
* @param {Guide_Large_Json_Files_S5_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s5_li3 = /** @type {((inputs?: Guide_Large_Json_Files_S5_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S5_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s5_li3(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s5_li3(inputs)
	return ja_guide_large_json_files_s5_li3(inputs)
});